var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Snackbar'),_c('Sidebar'),_c('Toolbar'),_c('v-main',{staticClass:"blue-grey lighten-4"},[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view')],1)],1),_c('v-overlay',{attrs:{"value":_vm.loading,"z-index":"1000"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }